import styled, { css } from 'styled-components'
import InputMask from 'react-input-mask'
import DatePicker from 'react-datepicker'
import { textModels, themeObject, textStyled } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	position: relative;
`

export const InputWrapper = styled.div`
	position: relative;
`
export const Error = styled.p`
	${textModels('notAdaptive', 'm', '400')}
	margin-top: 4px;
	color: ${themeObject.colors.red[500]};
`
export const Help = styled.p<{ isGreen?: boolean }>`
	${textStyled('SBSansInterface', 'regular', '16px', '24px', 'grey', '400')}
	${({ isGreen }) =>
		isGreen &&
		css`
			color: ${themeObject.colors.brand[500]};
			cursor: pointer;
		`}
margin-top: 4px;
`
export const input = css<{
	measure: string
	isError?: boolean
	disabled?: boolean
}>`
	${textModels('notAdaptive', 'm', '400')}
	width: 100%;
	border-radius: 8px;
	box-sizing: border-box;
	padding: 12px;
	color: ${themeObject.colors.grey[700]};
	background: ${themeObject.colors.base.white};
	box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]},
		0 0 0 30px ${themeObject.colors.base.white} inset !important;
	border: none;
	outline: none;
	&::placeholder {
		${textModels('notAdaptive', 'm', '400')}
		color: ${themeObject.colors.grey[400]};
	}
	&:hover {
		box-shadow: 0 0 0 1px ${themeObject.colors.brand[500]};
	}
	&:focus {
		box-shadow: 0 0 0 1px ${themeObject.colors.brand[500]},
			0 0 0 4px ${themeObject.colors.brand[200]};
	}
	${({ disabled }) =>
		disabled &&
		css`
			box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
			color: ${themeObject.colors.grey[300]};
		`}
	${({ isError }) =>
		isError &&
		css`
			box-shadow: 0 0 0 1px ${themeObject.colors.red[500]};
		`}
	${({ measure }) => {
		switch (measure) {
			case 'l':
				return css`
					height: 48px;
				`
			case 'm':
				return css`
					height: 40px;
				`
			default:
				return css``
		}
	}}
`
export const InputDefault = styled.input<{
	measure: string
	isError?: boolean
	disabled?: boolean
}>`
	${input}
`
export const InputPhone = styled(InputMask)<{
	measure: string
	isError?: boolean
	disabled?: boolean
}>`
	${input}
`
export const InputDate = styled(DatePicker)<{
	measure: string
	isError?: boolean
	disabled?: boolean
}>`
	${input}
`

export const IconWrapper = styled.span`
	position: absolute;
	height: 24px;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
`
